import { endpoint } from 'views/pages/manage/common/constant';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPostPromisedData, dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { hardcodeDropdown } from "../../common/services";


export const getCashDepositDetails = async ({
    pageNo = 0,
    pageSize = 10,
    setPaginationInfo,
    reqObj,
    fetchLogs = true
}) => {

    const { depositSlipId } = reqObj;
    const requests = [
        fetchAllPostPromisedData(
            `${endpoint?.cashManagement?.viewDetails?.search}?offset=${pageNo}&pageSize=${pageSize}`,
            reqObj,
            "post"
        )
    ];

    if (fetchLogs) {
        requests.push(
            fetchAllPromisedData(
                `${endpoint?.cashManagement?.viewDetails?.logs}/${depositSlipId}`
            )
        );
    }

    const [detailsResp, logsResp] = await Promise.all(requests);

    const CASHTYPE = hardcodeDropdown?.paymodeTypes?.[1]?.label;
    let paginationData = {};
    if (detailsResp?.code === 200) {
        paginationData = detailsResp?.data;
    }

    if (setPaginationInfo && paginationData) {
        setPaginationInfo({
            currPageNo: paginationData.currentPage ?? pageNo,
            currPageSize: pageSize,
            totalRecords: paginationData.totalRecords ?? 0,
            totalPage: paginationData?.totalPage
        });
    }

    return {
        details: {
            ...paginationData,
            receiptDetails: (paginationData?.receiptDetails || []).map(item => ({
                ...item,
                type: CASHTYPE
            }))
        },
        logs: logsResp
    };
};
